ready = ->
  window.wistiaPlayers = loadPlayers()
  # ENROLLED COURSE PAGE
  if currentUser()?.id
    currentUser().completedLectureIds.forEach((lectureId) ->
      $('.section-item[data-lecture-id="' + lectureId + '"]')
        .addClass("completed")
        .removeClass("incomplete")
        .removeClass("next-lecture")
    )
  setLabelsForCompleted()
  # Mark user's next incomplete lecture in curriculum list
  if $(".course-mainbar .incomplete").length > 0
    incomplete_lecture = $(".course-section:not(.course-section-locked) .incomplete").first()
    incomplete_lecture.addClass("next-lecture")
    setLabelForCurrent()
    # Start Next Lecture section
    $(".course-mainbar .next-lecture-name").append(incomplete_lecture.find(".lecture-name").html())
    $(".course-mainbar .start-next-lecture").attr("href", incomplete_lecture.find("a").attr("href"))

  else
    $(".course-mainbar .start-next-lecture").addClass("disabled") # Disable start next lecture button

  $(".product-enroll").click ->
    $("#enroll-button").click()
  return

setVideoHeight = (player) ->
  if $(player.container.parentElement).hasClass("wistia_responsive_wrapper")
    paddingWrapper = player.container.parentElement.parentElement

    # vertical
    paddingWrapper.style.paddingBottom = "56.25%"
    paddingWrapper.style.height = '0px'

loadPlayers = ->
  players = []
  playerElements = []
  for e in $('.show-course-wistia-player')
    playerElements.push(e)
  for e in $('.video-asset-wistia-player')
    playerElements.push(e)
  for element in playerElements
    brandPlayerColor = $('meta[name="brand_video_player_color"]').attr("content")
    playerColor = if $(element).data('player-color') then $(element).data('player-color') else brandPlayerColor
    stillUrl = $(element).data('thumbnail') || $(element).data('still-url')
    player = Wistia.embed($(element).data().wistiaId,
                          {
                            container: $(element).attr('id'),
                            playerPreference: "html5",
                            stillSnap: false,
                            videoFoam: true,
                            playerColor: playerColor,
                            stillUrl: stillUrl,
                            googleAnalytics: false
                          }
                        )
    promoVideo = $("#watchpromo")
    promoVideo.click ->
      if (Modernizr.videoautoplay && promoVideo.attr('id') not "watchpromo")
        player.play()

    setVideoHeight(player)

    players.push player
  return players

$(document).on("ready page:load", ready)

incomplete_lecture = $(".course-mainbar .incomplete")
$(".course-mainbar .next-lecture-name").html($(".course-mainbar .incomplete").first().find(".lecture-name").html())
$(".course-mainbar .start-next-lecture").attr("href", incomplete_lecture.find("a").attr("href"))

setLabelsForCompleted = ->
  $(".section-item .status-container").removeAttr('aria-label')
  $(".section-item.completed .status-container").attr('aria-label', 'Completed item')

setLabelForCurrent = ->
  $(".section-item.next-lecture .status-container").attr('aria-label', 'Current item')
